import { RootPaths } from "@src/appV2/App/paths";

export const MY_SHIFTS_PATH = "myShifts";
export const MY_SHIFTS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${MY_SHIFTS_PATH}`;

export const UNVERIFIED_SHIFTS_PATH = `${MY_SHIFTS_PATH}/unverifiedShifts`;
export const UNVERIFIED_SHIFTS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${MY_SHIFTS_PATH}/unverifiedShifts`;

export const BREAK_PAYMENT_REQUESTS_PATH = `${MY_SHIFTS_PATH}/break-payment-requests`;
export const BREAK_PAYMENT_REQUESTS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${BREAK_PAYMENT_REQUESTS_PATH}`;

export const SHIFT_INVITES_PATH = `${MY_SHIFTS_PATH}/shiftInvites`;
export const SHIFT_INVITES_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SHIFT_INVITES_PATH}`;

export const BOOKING_REQUESTS_PATH = `${MY_SHIFTS_PATH}/bookingRequests`;
export const BOOKING_REQUESTS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${BOOKING_REQUESTS_PATH}`;

export const SENT_HOME_REQUESTS_PATH = `${MY_SHIFTS_PATH}/sent-home-requests`;
export const SENT_HOME_REQUESTS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SENT_HOME_REQUESTS_PATH}`;

export const CREATE_SENT_HOME_REQUEST_PATH = `${MY_SHIFTS_PATH}/sent-home-request/create/:shiftId`;

export const CREATE_SHIFT_VERIFICATION_REQUEST_PATH = `${MY_SHIFTS_PATH}/verification-request/create/:shiftId`;
export const CREATE_SHIFT_VERIFICATION_REQUEST_FULL_PATH = `${RootPaths.APP_V2_HOME}/${CREATE_SHIFT_VERIFICATION_REQUEST_PATH}`;

export const SUBMIT_UNVERIFIED_TIMESHEET_PATH = `${MY_SHIFTS_PATH}/unverified-timesheet/:shiftId`;
export const SUBMIT_UNVERIFIED_TIMESHEET_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SUBMIT_UNVERIFIED_TIMESHEET_PATH}`;

export const SHIFT_DETAILS_PATH = `${MY_SHIFTS_PATH}/shift-details/:shiftId`;
export const SHIFT_DETAILS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SHIFT_DETAILS_PATH}`;
export const SHIFT_DETAILS_CLOCK_IN_QUERY_PARAM = "clockIn";

export const SHIFT_DETAILS_TIMEKEEPING_PATH = `/timekeeping`;
export const SHIFT_DETAILS_TIMEKEEPING_FULL_PATH = `${SHIFT_DETAILS_FULL_PATH}${SHIFT_DETAILS_TIMEKEEPING_PATH}`;

export const SHIFT_DETAILS_SUBMIT_TIMESHEET_PATH = `/submit-timesheet`;
export const SHIFT_DETAILS_SUBMIT_TIMESHEET_FULL_PATH = `${SHIFT_DETAILS_FULL_PATH}${SHIFT_DETAILS_SUBMIT_TIMESHEET_PATH}`;

export const SHIFT_DETAILS_UPDATE_ETA_PATH = `/update-eta`;
export const SHIFT_DETAILS_UPDATE_ETA_FULL_PATH = `${SHIFT_DETAILS_FULL_PATH}${SHIFT_DETAILS_UPDATE_ETA_PATH}`;

export const SHIFT_DETAILS_UPDATE_ETA_CONFIRMED_PATH = `/update-eta-confirmed`;
export const SHIFT_DETAILS_UPDATE_ETA_CONFIRMED_FULL_PATH = `${SHIFT_DETAILS_FULL_PATH}${SHIFT_DETAILS_UPDATE_ETA_CONFIRMED_PATH}`;

export const SHIFT_DETAILS_OPEN_GEOLOCATION_PATH = `/open-maps`;
export const SHIFT_DETAILS_OPEN_GEOLOCATION_FULL_PATH = `${SHIFT_DETAILS_FULL_PATH}${SHIFT_DETAILS_OPEN_GEOLOCATION_PATH}`;

export const IN_HOME_COMMS_BANNER_PATH = `${MY_SHIFTS_PATH}/in-home-comms-banner`;
export const IN_HOME_COMMS_BANNER_FULL_PATH = `${RootPaths.APP_V2_HOME}/${IN_HOME_COMMS_BANNER_PATH}`;

export const SHIFT_HISTORY_PATH = `${MY_SHIFTS_PATH}/shift-history`;
export const SHIFT_HISTORY_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SHIFT_HISTORY_PATH}`;

export const SHIFT_DETAILS_CONFIRM_ATTENDANCE_PATH = `/confirm-attendance`;

export const SHIFT_DETAILS_ATTENDANCE_CONFIRMED_PATH = `/attendance-confirmed`;
export const SHIFT_DETAILS_ATTENDANCE_CONFIRMED_FULL_PATH = `${SHIFT_DETAILS_FULL_PATH}${SHIFT_DETAILS_ATTENDANCE_CONFIRMED_PATH}`;

export const MY_SHIFTS_BACKGROUND_CHECK_ERROR_PATH = `/background-check-error`;
export const MY_SHIFTS_BACKGROUND_CHECK_ERROR_FULL_PATH = `${MY_SHIFTS_FULL_PATH}${MY_SHIFTS_BACKGROUND_CHECK_ERROR_PATH}`;
